import animation from './animation.js'

/* GeomAxis : keep and modify position and length of 1D object
 *
 *
 *           <------------- lim.max ------------->
 *           <--- lim.min --->
 * |---------|===============^============|------^-----------|
 * 0         pos                                             ext
 *           <----------- len ------------>
 *
 * Only object {pos, len} is modified.
 * Auto checked:
 *              0 <= pos, lim.min <= len <= lim.max, pos+len <= ext
*/
export default class GeomAxis {
  constructor(obj={pos: 0, len: 0}, ext=undefined, lim={}) {
    this.obj = obj
    this.ext = ext !== undefined ? ext : 99999
    this.lim = {
      min: lim.min !== undefined ? lim.min : 0,
      max: lim.max !== undefined ? lim.max : this.ext
    }
    this.check()
    this.save()
  }
  save() {
    this.old = Object.assign({}, this.obj)
  }
  check(res=true) {
    if(this.lim.min > this.ext || this.lim.min < 0)
      throw 'Incorrect lim min'
    if(this.lim.max < this.lim.min)
      throw 'Incorrect lim max'
    if(this.obj.pos < 0) {
      this.obj.pos = 0
      res = false
    }
    if(this.obj.len < this.lim.min) {
      this.obj.len = this.lim.min
      res = false
    }
    if(this.obj.len > this.lim.max) {
      this.obj.len = this.lim.max
      res = false
    }
    if(this.obj.len > this.ext) {
      this.obj.len = this.ext
      res = false
    }
    if(this.obj.pos + this.obj.len > this.ext) {
      this.obj.pos = this.ext - this.obj.len
      res = false
    }
    return res
  }
  move(dpos=0) {
    this.save()
    this.obj.pos+= dpos
    this.check()
    return this.getPosDelt()
  }
  moveTo(pos=null) {
    pos = (pos !== null) ? pos : this.obj.pos
    return this.move(pos-this.obj.pos)
  }
  resize(dlen=0, dir=1) {
    this.save()
    if(dir > 0) {
      this.obj.len+= dlen
    }
    if(dir < 0) {
      this.obj.pos+= dlen
      this.obj.len-= dlen
    }
    if(this.obj.pos + this.obj.len > this.ext)
      this.obj.len = this.ext - this.obj.pos
    this.check()
    return {
      dpos: this.getPosDelt(),
      dlen: this.getLenDelt()
    }
  }
  resizeTo(len=null, dir=1) {
    len = (len !== null) ? len : this.obj.len
    return this.resize(len - this.obj.len, dir)
  }
  increase(delt=1) {
    this.save()
    this.obj.len+= delt*2
    this.obj.pos-= delt
    this.check()
    return this.getLenDelt()
  }
  maximize(delt=1) {
    animation(() => this.increase(delt))
  }
  minimize(delt=1) {
    animation(() => this.increase(-delt))
  }
  getPosDelt() {
    return this.obj.pos - this.old.pos
  }
  getLenDelt() {
    return this.obj.len - this.old.len
  }
}



// WEBPACK FOOTER //
// ./src/float/vue/utils/GeomAxis.js